"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _redux = require("../redux");
var _i18n = require("../i18n");
var _router = require("../router");
var _apollo = require("../apollo");
var _grid = require("../grid");
var _styled = require("../styled");
var _themes = require("../themes");
var _AppContainer = _interopRequireDefault(require("./AppContainer"));
var _initState = _interopRequireDefault(require("./initState"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var createApolloState = function createApolloState(props) {
  if (props.apiUrl != null) {
    if (props.client != null || props.store != null) {
      throw new Error('Props `client` and `store` are incompatible with `apiUrl`');
    }
    return (0, _initState.default)({
      apiUrl: props.apiUrl,
      persistSharedState: props.persistSharedState,
      storeConfig: props.storeConfig,
      cacheConfig: props.cacheConfig
    });
  }
  if (props.client == null || props.store == null) {
    throw new Error('Props `client` and `store` are required when `apiUrl` is omitted');
  }
  return {
    client: props.client,
    store: props.store
  };
};
var createThemeState = function createThemeState(props) {
  return {
    theme: props.theme || (0, _themes.getTheme)(props.brand, (0, _themes.getLocalTheme)(props.brand))
  };
};
var createLocaleState = function createLocaleState(props) {
  if (props.locale == null) {
    var brandLocale = (0, _i18n.getLocale)(props.brand);
    return {
      locale: brandLocale.locale
    };
  }
  return {
    locale: props.locale
  };
};
var Root = /*#__PURE__*/function (_Component) {
  function Root() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = Object.assign({}, createApolloState(_this.props), createThemeState(_this.props), createLocaleState(_this.props));
    return _this;
  }
  (0, _inheritsLoose2.default)(Root, _Component);
  var _proto = Root.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.brand !== this.props.brand || nextProps.theme !== this.props.theme) {
      this.setState(createThemeState(nextProps));
    }
    if (nextProps.brand !== this.props.brand || nextProps.locale !== this.props.locale) {
      this.setState(createLocaleState(nextProps));
    }
    if (nextProps.client !== this.props.client || nextProps.store !== this.props.store || nextProps.apiUrl !== this.props.apiUrl) {
      this.setState(createApolloState(nextProps));
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      messages = _this$props.messages,
      basename = _this$props.basename,
      rhl = _this$props.rhl;
    var _this$state = this.state,
      client = _this$state.client,
      store = _this$state.store,
      theme = _this$state.theme,
      locale = _this$state.locale;
    var GlobalStyles = theme.GlobalStyles;
    return /*#__PURE__*/_react.default.createElement(_AppContainer.default, {
      rhl: rhl,
      warnings: false
    }, /*#__PURE__*/_react.default.createElement(_i18n.IntlProvider, {
      locale: locale,
      key: locale,
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(_router.BrowserRouter, {
      basename: basename
    }, /*#__PURE__*/_react.default.createElement(_redux.Provider, {
      store: store
    }, /*#__PURE__*/_react.default.createElement(_apollo.ApolloProvider, {
      client: client
    }, /*#__PURE__*/_react.default.createElement(_styled.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(_grid.BreakpointProvider, null, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(GlobalStyles, null), children))))))));
  };
  return Root;
}(_react.Component);
Root.defaultProps = {
  apiUrl: null,
  client: null,
  store: null,
  theme: null,
  brand: null,
  messages: _i18n.messages,
  basename: '',
  rhl: true
};
var _default = exports.default = Root;